import { useMutation } from "@apollo/client";
import { useCallback } from "react";
import { GET_MY_SETTINGS } from "../api/get-my-settings";
import { SAVE_PERSON_LANGUAGE_SETTINGS } from "../api/save-person-language";
import { Locale } from "@/shared/i18n/config";
import { SupportedLanguages } from "gql/graphql";

const lowToUpLang: Record<Locale, SupportedLanguages> = {
  en: SupportedLanguages.En,
  ru: SupportedLanguages.Ru,
  kz: SupportedLanguages.Kz,
  uz: SupportedLanguages.Uz,
};

export function usePersonLanguageMutation() {
  const [saveLang, { loading }] = useMutation(SAVE_PERSON_LANGUAGE_SETTINGS, {
    refetchQueries: [GET_MY_SETTINGS],
  });

  const save = useCallback(
    async (lang: Locale) => {
      await saveLang({
        variables: {
          settings: {
            primaryLanguage: lowToUpLang[lang],
          },
        },
      });
    },
    [saveLang],
  );

  return { save, loading };
}
